import { render, staticRenderFns } from "./PostponeRoamingDialog.vue?vue&type=template&id=48cd4214"
import script from "./PostponeRoamingDialog.vue?vue&type=script&lang=js"
export * from "./PostponeRoamingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports